// @flow

import type {
  CreateState,
} from './types';

const initialState: CreateState = {
  availablePrompts: [],
  currentEditorId: null,
  apicallInProgress: false,
  imageUploadingInProgress: false,
};

export {
  // eslint-disable-next-line import/prefer-default-export
  initialState,
};
